jQuery(document).ready(function ($) {
    if ($('.table-of-contents-wrapper').length === 0) {
        return;
    }

    $('.table-of-contents-wrapper li a').on('click', function(e) {
        e.preventDefault();
        let target = $(this).attr("href");
        let offset = $(target).offset().top - 240;
        $("html, body").animate({ scrollTop: offset }, 500);
    });

    $('.table-of-contents-wrapper li a').each(function () {
        var id = $(this).attr('href').replace('#', '');
        var text = $(this).text().trim();

        $('h2, h3, h4, h5, h6').each(function() {
            if ($(this).text().trim() === text) {
                $(this).attr('id', id);
                return;
            }
        })
    });
});